"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_DIVIDEND_TAX_PERCENT = exports.updateAppSettingsSchema = void 0;
const zod_1 = require("zod");
/**
 * Global (per-instance) application settings — a single small record, not a
 * per-firm one. v1 carries only the dividend tax rate the dashboard's Profit
 * widget estimates with; the shape leaves room to grow.
 */
exports.updateAppSettingsSchema = zod_1.z.object({
    /** Cota de impozit pe dividende (%), ca string zecimal — ex. "10" sau
     * "10.00". Se aplică la estimarea "net după distribuirea dividendelor". */
    dividendTaxPercent: zod_1.z
        .string()
        .trim()
        .regex(/^\d{1,2}(\.\d{1,2})?$/, 'Cota trebuie să fie un procent între 0 și 99.99, cu cel mult 2 zecimale.'),
});
/** Default folosit până la prima salvare: cota în vigoare din 2025. */
exports.DEFAULT_DIVIDEND_TAX_PERCENT = '10';
